import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from "@mui/material/Typography";
import classNames from 'classnames';
import { visuallyHidden } from '@mui/utils';

// const ConditionalWrapper = ({condition, wrapper, children}) =>
//   condition == 'contained' ? wrapper(children) : children;

// Can be undefined in Storybook:
// const localStorageKey = process.env.LOCAL_STORAGE_KEY;

const optsDefault = {
  titleBgWide: false,
  titleBgClr: false,
  mainBgClr: false,
  mainBgImg: false,
  sideBgClr: false,
  topBgClr: false,
};

const useStyles = makeStyles((theme) =>
  createStyles({
    pageBG: {
      backgroundImage: props => props.opts.mainBgImg ? `url(${props.opts.mainBgImg}) !important` : 'none',
      backgroundSize: '100% auto !important',
      backgroundPosition: 'top'
    },
    articleImageContainer: {
      lineHeight: '0',
      "& img": {
        objectFit: 'cover',
        objectPosition: 'center center',
      }
    },
    pageBody: {
      "& p:not(.MuiTypography-root)": {
        fontSize: 18,
      },
    },
  }),
);

function NoSidebarLayout(props) {
  let {title, hideTitle, html_title, summary, top_region, sidebar, opts, children} = props;
  opts = {...optsDefault, ...opts};
  const classes = useStyles(props);

  return (
    <Box>
      {top_region &&
      <Box {...(opts.topBgClr ? {bgcolor: opts.topBgClr} : {})}>
        <Container  className="alignfull">
          <Grid container>
            <Grid item xs={12} className={classes.articleImageContainer}>
              {top_region}
            </Grid>
          </Grid>
        </Container>
      </Box>
      }
      {title && !hideTitle &&
        <Box my={4}>
          <Typography variant="h1" className={`page-title`}>{title}</Typography>
        </Box>
      }
      {title && hideTitle &&
      <Typography variant="h1" style={visuallyHidden} className={`MuiTypography-srOnly`}>{title}</Typography>
      }

      <div className={classNames(opts.mainBgImg ? classes.pageBG : '')}>
        <Box pb="2rem" {...(opts.mainBgClr ? {bgcolor: opts.mainBgClr} : {})}>
            <Grid container spacing={4}>
              <Grid item xs={12} className={`${classes.pageBody} main-body`}>
                {children}
              </Grid>
            </Grid>
        </Box>
      </div>
    </Box>
  );
}

export default NoSidebarLayout;
